import { Button, Menu, MenuItem, Fade } from '@mui/material'
import { FC, useCallback, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Nav } from '../../containers/_nav'
import { conditionalClasses } from '../../utils/helper-functions'
import NavigationLink from './navigation-link'

interface NavigationMenuProps {
    nav: Nav
    _class?: string
    onClick?: () => void
}

const NavigationMenu: FC<NavigationMenuProps> = ({
    nav,
    _class = '',
    onClick = () => {
        // This is intentional
    },
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const location = useLocation()
    const open = Boolean(anchorEl)
    const handleClick = useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget)
        },
        [setAnchorEl]
    )
    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [setAnchorEl])

    return (
        <li className={_class} onClick={onClick}>
            {nav.link ? (
                <NavigationLink
                    className={conditionalClasses(
                        nav.link === location.pathname,
                        'active'
                    )}
                    link={nav.link}
                    target="_blank"
                    id={nav.click_id}
                >
                    {nav.icon && <img src={nav.icon} alt="icon" />}
                    {nav.label}
                </NavigationLink>
            ) : (
                <>
                    {nav.subMenu ? ( //NOSONAR This is intentional
                        <div>
                            <Button
                                id={nav.key}
                                aria-controls={conditionalClasses(
                                    open,
                                    'fade-menu',
                                    undefined
                                )}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined} //NOSONAR This is intentional
                                onClick={handleClick}
                                disableRipple
                            >
                                {nav.label}
                            </Button>
                            <Menu
                                id={nav.key}
                                MenuListProps={{
                                    'aria-labelledby': 'fade-button',
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                TransitionComponent={Fade}
                                className="submenu"
                            >
                                {nav.subMenu.map((navItem) => (
                                    <MenuItem disableRipple key={navItem.key}>
                                        <Link
                                            className={conditionalClasses(
                                                navItem.link ===
                                                    location.pathname,
                                                'active'
                                            )}
                                            onClick={handleClose}
                                            to={
                                                navItem.link ? navItem.link : ''
                                            }
                                        >
                                            {navItem.label}
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </div>
                    ) : (
                        <label>
                            {nav.icon && <img src={nav.icon} alt="icon" />}
                            {nav.label}
                        </label>
                    )}
                </>
            )}
        </li>
    )
}

export default NavigationMenu
